import { FC } from 'react';

import MenuBar from '@3.0/MenuBar';
import DataSourcesMenuBarLabel from './DataSourcesMenuBarLabel';

type TProps = {
  setSearchTerm: (term: string) => void;
};

const DataSourcesMenuBar: FC<TProps> = ({ setSearchTerm }) => {
  return (
    <MenuBar
      labelProps={{ className: 'tw:w-full tw:shrink-0' }}
      label={<DataSourcesMenuBarLabel setSearchTerm={setSearchTerm} />}
      actionButtons={[]}
      className="tw:border-t-0"
      mode="shade"
      variant="default"
    />
  );
};

export default DataSourcesMenuBar;
